<template>
  <div id="productorders">
    <v-card class="mx-auto" max-width="100%" outlined>
      <v-row no-gutters class="align-center">
        <v-card-title class="text-h4">
          {{ $i18n.t("headings.product") + " " + $i18n.t("headings.quotes") }}
          <!-- <helper topic="classes" /> -->
        </v-card-title>
        <v-spacer />
        <v-btn
          v-show="
            isValidOwnerField(decodedRouteParamOwner) &&
            isAmplifyDataStoreId($route.params.teacherProfileId)
            // &&
            // nonPendingOrders?.length === 0
          "
          color="primary"
          class="mx-4"
          @click="createItem"
          :disabled="offline"
        >
          {{ $i18n.t("otherText.new") + " " + $i18n.t("headings.quote") }}
        </v-btn>
      </v-row>

      <v-row class="px-4 mt-0 pb-4 align-center">
        <v-col cols="12" sm="6" md="8">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-col>
        <v-col cols="6" sm="3" md="2">
          <v-checkbox
            v-model="searchPhysicalProductOrders"
            label="Has Physical Product"
            class="mt-0"
            style="margin-bottom: -24px"
          ></v-checkbox
        ></v-col>
        <v-col cols="6" sm="3" md="2">
          <v-checkbox
            v-model="searchQuestionProductOrders"
            label="Has Questions"
            class="mt-0"
            style="margin-bottom: -24px"
          ></v-checkbox
        ></v-col>
      </v-row>

      <v-row class="px-4 pb-4 align-center">
        <v-col cols="12" sm="4" md="3">
          <v-menu
            v-model="showStartDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="filterStartDate"
                label="From Date"
                prepend-icon="mdi-calendar"
                readonly
                required
                :rules="formRules.required"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filterStartDate"
              no-title
              scrollable
              @input="showStartDateMenu = false"
            ></v-date-picker>
          </v-menu>

          <!-- <DateTimePicker
            v-model="filterStartDate"
            label="Start Date"
            required
          /> -->
        </v-col>

        <v-col cols="12" sm="4" md="3">
          <v-menu
            v-model="showEndDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="filterEndDate"
                label="To Date"
                prepend-icon="mdi-calendar"
                readonly
                required
                :rules="formRules.required"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filterEndDate"
              no-title
              scrollable
              @input="showEndDateMenu = false"
            ></v-date-picker>
          </v-menu>

          <!-- <DateTimePicker v-model="filterEndDate" label="End Date" required /> -->
        </v-col>

        <!-- <v-col cols="12" sm="4" md="3">
          <v-select
            v-model="filterStatuses"
            :items="orderStatuses"
            label="Order Status"
            multiple
            clearable
            chips
            small-chips
          ></v-select>
        </v-col> -->
      </v-row>

      <div class="px-4">
        <v-data-table
          :footer-props="{
            showFirstLastPage: true,
            itemsPerPageOptions: [5, 10, 15, 50, 100],
          }"
          :headers="headers"
          :items="filteredOrders"
          :sort-by="sortBy"
          :sort-desc="sortDesc"
          must-sort
          :custom-sort="customSort"
          show-group-by
          no-data-text="No Quotes found"
          :loading="!syncedProductOrders"
          loading-text="Loading Quotes..."
        >
          <!-- <template v-slot:[`item.orderID`]="{ item }">
            {{ `#${item.orderID}` }}
          </template> -->
          <template v-slot:[`item.orderDateTime`]="{ item }">
            {{ formatDate(item.orderDateTime) }}
          </template>
          <template v-slot:[`item.orderTotal`]="{ item }">
            {{ "R" + (item.orderTotal || 0).toFixed(2) }}
          </template>
          <template v-slot:[`item.orderProducts`]="{ item }">
            {{ item.orderProducts?.length > 0 ? item.orderProducts.length : 0 }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              v-show="item.orderStatus !== 'PAID'"
              small
              class="mr-2"
              @click="editItem(item)"
              :disabled="offline"
            >
              mdi-pencil
            </v-icon>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
              v-show="item.orderStatus === 'QUOTING'"
                  small
              :loading="sendingEmails[item.id]"
              :disabled="offline || sendingEmails[item.id]"
              @click="sendProductOrderEmail(item)"
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-email
                </v-icon>
              </template>
              <span>Send quote email</span>
            </v-tooltip>

            <v-icon small @click="viewItem(item)"> mdi-eye </v-icon>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card class="overflow-x-hidden overflow-y-auto" max-height="90vh">
        <v-form ref="form" v-model="valid" @submit.prevent="save">
          <v-card-title>
            <span class="text-h5">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <p>Date: {{ formatDate(editedItem.orderDateTime) }}</p>

                  <p>
                    {{
                      $i18n.t("headings.order") +
                      " " +
                      $i18n.t("otherText.id") +
                      ": " +
                      editedItem.orderID
                    }}
                  </p>

                  <p v-if="editedItem.coupon">
                    {{ $i18n.t("labels.coupon") + ": " }}
                    <span class="primary--text">
                      {{ editedItem.coupon.couponCode }}</span
                    >
                  </p>

                  <p
                    v-if="
                      editedIndex === -1 ||
                      (editedIndex > -1 &&
                        (editedItem.orderStatus === 'PAID' ||
                          editedItem.orderStatus === 'CANCELLED' ||
                          editedItem.orderStatus === 'DECLINED') &&
                        !unsavedChanges)
                    "
                  >
                    {{
                      $i18n.t("labels.status") + ": " + editedItem.orderStatus
                    }}
                  </p>
                  <v-select
                    v-else
                    :value="editedItem.orderStatus"
                    :items="eftStatuses"
                    @change="updateOrderStatus"
                    :label="`${$i18n.t('labels.status')}:`"
                  ></v-select>

                  <v-textarea
                    v-model="quoteNote"
                    label="Quote Note (added to the quote email)"
                    outlined
                    auto-grow
                    rows="2"
                    class="mb-4"
                    hide-details="auto"
                    :readonly="!orderFieldsEditable"
                  ></v-textarea>

                  <p v-show="editedItem.orderPaymentMethod > ''">
                    Payment Method: {{ editedItem.orderPaymentMethod }}
                  </p>

                  <div v-if="!orderFieldsEditable">
                    <p>
                      {{ $i18n.t("headings.products") + ":" }}
                    </p>
                    <v-row style="gap: 8px" no-gutters>
                      <v-chip
                        v-for="(
                          orderProduct, opIndex
                        ) in editedItem.orderProducts"
                        :key="opIndex"
                        class="text-wrap py-1"
                        :to="`/app/products/${orderProduct.id}`"
                        style="height: fit-content"
                        >{{ orderProduct.title }}</v-chip
                      ></v-row
                    >
                  </div>
                  <v-autocomplete
                    v-else
                    v-model="editedItem.orderProducts"
                    @change="updateOrderProducts"
                    :items="productSelectArray"
                    item-text="title"
                    item-value="id"
                    :label="`${$i18n.t('headings.products')}*`"
                    return-object
                    required
                    :rules="formRules.products"
                    :loading="!syncedProducts || !syncedProductBundles"
                    chips
                    clearable
                    deletable-chips
                    multiple
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" v-if="orderFieldsEditable">
                  <div class="d-flex flex-row align-center" style="gap: 12px">
                    <v-text-field
                      v-model="couponCode"
                      :label="`${$i18n.t('labels.couponCode')}`"
                      :error-messages="couponVerifyErrors"
                      @keyup.enter="verifyCoupon"
                      @input="onCouponCodeInput"
                    ></v-text-field>

                    <v-icon
                      v-if="
                        editedItem.coupon &&
                        editedItem.coupon.couponCode === couponCode
                      "
                      color="primary"
                      >mdi-check</v-icon
                    >

                    <v-btn
                      color="primary"
                      v-else
                      :disabled="
                        verifyingCoupon || !couponCode || couponCode === ''
                      "
                      :loading="verifyingCoupon"
                      @click="verifyCoupon"
                      >{{ $i18n.t("actions.verify") }}</v-btn
                    >
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  v-if="
                    orderFieldsEditable &&
                    editedItemProductsWithAddons.length > 0
                  "
                >
                  <v-card-title class="pt-0 pl-0" style="margin-left: -12px">
                    <span class="text-h5">Addons</span>
                  </v-card-title>

                  <div class="mt-4">
                    <div
                      v-for="(product, pIndex) in editedItemProductsWithAddons"
                      :key="pIndex"
                    >
                      <v-select
                        v-if="getAvailableAddons(product.id).length > 0"
                        v-model="product.addons"
                        :items="getAvailableAddons(product.id)"
                        item-text="title"
                        return-object
                        multiple
                        :label="`Select Addons for ${product.title}`"
                        chips
                        :deletable-chips="orderFieldsEditable"
                      >
                        <template v-slot:selection="{ item }">
                          <v-chip
                            class="ma-1"
                            :input-value="true"
                            :close="orderFieldsEditable"
                            @click:close="removeAddonFromProduct(product, item)"
                          >
                            {{ item.title }} ({{ item.type }}) - R{{
                              item.price.toFixed(2)
                            }}
                          </v-chip>
                        </template>
                        <template v-slot:item="{ item }">
                          {{ item.title }} ({{ item.type }}) - R{{
                            item.price.toFixed(2)
                          }}
                        </template>
                      </v-select>
                    </div>
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  v-show="editedItem.orderProducts?.length > 0"
                  style="font-size: 1.3rem; line-height: 1.5"
                >
                  <v-row no-gutters>
                    {{
                      $i18n.t("headings.products") +
                      " (" +
                      $i18n.t("labels.downloadable") +
                      ")"
                    }}: <v-spacer></v-spacer>

                    R{{ editedItemNonPhysicalProductsPrice.toFixed(2) }}
                  </v-row>

                  <v-row no-gutters v-if="editedItemAddonsTotal > 0">
                    {{ $i18n.t("labels.addons") }}: <v-spacer></v-spacer> R
                    {{ editedItemAddonsTotal.toFixed(2) }}
                  </v-row>

                  <v-row no-gutters>
                    {{
                      $i18n.t("headings.products") +
                      " (" +
                      $i18n.t("headings.shipping") +
                      ")"
                    }}: <v-spacer></v-spacer> R{{
                      editedItemPhysicalProductsPrice.toFixed(2)
                    }}
                  </v-row>

                  <v-row
                    no-gutters
                    v-show="editedItemPhysicalProducts?.length > 0"
                  >
                    {{ $i18n.t("headings.shippingFee") }}:
                    <v-spacer></v-spacer> R
                    {{ (130).toFixed(2) }}
                  </v-row>

                  <v-row no-gutters v-show="editedItem.coupon">
                    {{ $i18n.t("labels.coupon") }}: <v-spacer></v-spacer> -R{{
                      editedItemDiscountAmount.toFixed(2)
                    }}
                  </v-row>

                  <v-row no-gutters>
                    {{
                      $i18n.t("labels.subTotal") +
                      " (" +
                      $i18n.t("labels.vatIncluded") +
                      ")"
                    }}: <v-spacer></v-spacer> R
                    {{ editedItemSubTotal.toFixed(2) }}
                  </v-row>
                  <v-row no-gutters>
                    {{
                      $i18n.t("labels.total") +
                      " (" +
                      $i18n.t("labels.vatExcluded") +
                      ")"
                    }}: <v-spacer></v-spacer> R
                    {{ editedItemExclVAT.toFixed(2) }}
                  </v-row>
                  <v-row no-gutters>
                    {{ $i18n.t("labels.vat") }} ( 15% ): <v-spacer></v-spacer> R
                    {{ editedItemTotalVat.toFixed(2) }}
                  </v-row>
                  <v-row no-gutters>
                    {{ $i18n.t("labels.total") }}: <v-spacer></v-spacer> R
                    {{ editedItemSubTotal.toFixed(2) }}
                  </v-row>
                </v-col>

                <v-col
                  cols="12"
                  v-show="editedItem.orderPaymentMethod === 'EFT'"
                >
                  <v-card class="pa-3">
                    <span class="mb-0 text-subtitle-1"
                      ><strong>Bank Details:</strong></span
                    >
                    <p class="mb-0">Account holder: A Dempers</p>
                    <p class="mb-0">Account number: 1216434069</p>
                    <p class="mb-0">Account type: Current account</p>
                    <p class="mb-0">Bank name: Nedbank</p>
                    <p class="mb-0">Branch code: 198765</p>
                    <p class="mb-0">Reference: {{ editedItem.orderID }}</p>
                    <p class="mb-0">
                      Proof of payment: info@juffrouanri.com / +27 60 529 4868
                    </p>
                    <p class="mb-0">
                      Please email a bank-generated PDF proof of payment
                      (screenshots are not accepted), so that your order can be
                      verified and released.
                    </p>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <div v-if="editedItemProductsQuestions?.length > 0">
            <v-card-title class="pt-0">
              <span class="text-h5">Questions</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <div
                  v-for="(
                    productWithQuestions, productWithQuestionsIndex
                  ) in editedItemProductsQuestions"
                  :key="productWithQuestionsIndex"
                >
                  <span class="text-h6">{{ productWithQuestions.title }}</span>

                  <v-row>
                    <v-col cols="12">
                      <template
                        v-for="(
                          question, questionIndex
                        ) in productWithQuestions.questions"
                      >
                        <v-text-field
                          v-if="question.type === 'Text'"
                          :key="'text-' + questionIndex"
                          v-model="question.value"
                          :label="question.label"
                          :hint="question.hint"
                          :placeholder="question.placeholder"
                          @dblclick="copyPlaceholderToValue(question)"
                          :required="question.required"
                          :readonly="!orderFieldsEditable"
                          :rules="question.required ? formRules.required : []"
                        ></v-text-field>
                        <v-textarea
                          v-if="question.type === 'Textarea'"
                          :key="'textarea-' + questionIndex"
                          v-model="question.value"
                          :label="question.label"
                          :hint="question.hint"
                          :placeholder="question.placeholder"
                          @dblclick="copyPlaceholderToValue(question)"
                          auto-grow
                          :required="question.required"
                          :readonly="!orderFieldsEditable"
                          :rules="question.required ? formRules.required : []"
                        ></v-textarea>
                        <v-select
                          v-if="
                            question.type === 'Select' ||
                            question.type === 'Multi Select'
                          "
                          :key="'select-' + questionIndex"
                          v-model="question.value"
                          :label="question.label"
                          :items="question.items"
                          :hint="question.hint"
                          :placeholder="question.placeholder"
                          :multiple="question.type === 'Multi Select'"
                          :required="question.required"
                          :readonly="!orderFieldsEditable"
                          :rules="question.required ? formRules.required : []"
                        ></v-select>
                        <v-radio-group
                          v-if="question.type === 'Radio'"
                          :key="'radio-' + questionIndex"
                          v-model="question.value"
                          :label="question.label"
                          :hint="question.hint"
                          :readonly="!orderFieldsEditable"
                          :rules="question.required ? formRules.required : []"
                        >
                          <v-radio
                            v-for="(item, itemIndex) in question.items"
                            :key="'item-' + itemIndex"
                            :label="item"
                            :value="item"
                          ></v-radio>
                        </v-radio-group>
                        <div
                          v-if="question.type === 'Checkbox'"
                          :key="'checkbox-container-' + questionIndex"
                        >
                          <span class="v-label">{{ question.label }}</span>
                          <template>
                            <v-checkbox
                              v-for="(item, itemIndex) in question.items"
                              :key="
                                'checkbox-' + questionIndex + '-' + itemIndex
                              "
                              v-model="question.value"
                              :value="item"
                              :label="item"
                              :readonly="!orderFieldsEditable"
                              :rules="
                                question.required ? formRules.required : []
                              "
                            ></v-checkbox>
                          </template>
                        </div>
                      </template>
                    </v-col>
                  </v-row>
                </div>
              </v-container>
            </v-card-text>
          </div>

          <div v-if="editedItemPhysicalProducts?.length > 0">
            <v-card-title class="py-0" style="gap: 12px">
              <span class="text-h5">{{
                $i18n.t("headings.shippingInfo")
              }}</span>
              <v-spacer></v-spacer>
              <v-btn
                v-show="
                  ['PROCESSING', 'QUOTING', 'DRAFT'].includes(
                    editedItem.orderStatus,
                  ) &&
                  isValidOwnerField(decodedRouteParamOwner) &&
                  isAmplifyDataStoreId($route.params.teacherProfileId)
                "
                color="primary"
                @click="fetchTeacherShippingDetails"
                :loading="gettingTeacherShippingDetails"
                :disabled="gettingTeacherShippingDetails || offline"
              >
                Fetch Shipping Details
              </v-btn>
            </v-card-title>

            <div
              v-show="noShippingDetailsFound && !gettingTeacherShippingDetails"
              class="px-4 pt-6"
            >
              <v-alert class="mb-0" type="warning">{{
                $i18n.t("products.noShippingDetailsFound")
              }}</v-alert>
            </div>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="shippingDetails.address1"
                      :label="`${$i18n.t('labels.address')} 1`"
                      :rules="formRules.address1"
                      required
                      :readonly="!orderFieldsEditable"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="shippingDetails.address2"
                      :label="`${$i18n.t('labels.address')} 2`"
                      :readonly="!orderFieldsEditable"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="shippingDetails.city"
                      :label="$i18n.t('labels.city')"
                      :rules="formRules.city"
                      required
                      :readonly="!orderFieldsEditable"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="shippingDetails.province"
                      :items="provinces"
                      :label="`${$i18n.t('labels.province')}*`"
                      :rules="formRules.province"
                      required
                      :readonly="!orderFieldsEditable"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="shippingDetails.postalCode"
                      :label="$i18n.t('labels.postalCode')"
                      :rules="formRules.postalCode"
                      required
                      :readonly="!orderFieldsEditable"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="shippingDetails.country"
                      readonly
                      :label="$i18n.t('labels.country')"
                      :rules="formRules.country"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="shippingDetails.phoneNumber"
                      :label="
                        $i18n.t('labels.phone') + ' ' + $i18n.t('labels.number')
                      "
                      :rules="formRules.phoneNumber"
                      required
                      :readonly="!orderFieldsEditable"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row
                  v-show="
                    isValidOwnerField(decodedRouteParamOwner) &&
                    isAmplifyDataStoreId($route.params.teacherProfileId) &&
                    (shippingChanged || savedShippingDetails)
                  "
                  no-gutters
                >
                  <div>
                    {{ $i18n.t("products.saveShipping") }}
                    <v-btn
                      color="green"
                      class="ml-3 white--text"
                      :disabled="
                        !shippingChanged ||
                        savingTeacherShippingDetails ||
                        offline
                      "
                      :loading="savingTeacherShippingDetails"
                      @click="saveTeacherShippingDetails"
                      >{{ $i18n.t("actions.yes") }}</v-btn
                    >
                  </div>

                  <div
                    v-if="savedShippingDetails && !savingTeacherShippingDetails"
                    class="ml-3 d-flex align-center"
                  >
                    <!-- {{ $i18n.t("actions.saved") + "!" }} -->
                    <v-icon color="success" class="slide-x-transition">
                      mdi-check-circle
                    </v-icon>
                  </div>
                </v-row>
              </v-container>
            </v-card-text>
          </div>

          <v-card-actions>
            <v-spacer v-show="editedIndex === -1"></v-spacer>
            <v-btn
              color="primary"
              @click="close"
              :disabled="savingProductOrder"
            >
              {{ $i18n.t("actions.close") }}
            </v-btn>
            <v-spacer v-show="editedIndex > -1"></v-spacer>
            <v-btn
              v-show="editedIndex > -1"
              :disabled="!valid || !unsavedChanges || savingProductOrder"
              :loading="savingProductOrder"
              color="primary"
              @click="save"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="createDialog" max-width="500px">
      <v-card class="overflow-x-hidden overflow-y-auto" max-height="90vh">
        <v-form ref="form" v-model="validCreate" @submit.prevent="save">
          <v-card-title>
            <span class="text-h5">{{
              $i18n.t("actions.create") +
              " " +
              $i18n.t("headings.product") +
              " " +
              $i18n.t("headings.quote")
            }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <!-- createdAt : "2024-10-03T13:25:49.684Z" 
                id : "04fb13c7-22cc-4411-9b6e-e4bcdbac7bcb"
                orderDateTime : "2024-10-03T13:26:03.000Z"
                orderID : "20241003-152603"
                orderPayment : null
                orderPaymentMethod : "EFT"
                orderProducts : [{…}]
                orderShippingDetails : null
                orderStatus : "PAID"
                orderTotal : 95
                orderVAT : 12.39
                owner : "anridempers"
                teacherprofileID : "7d2b4902-ca79-4539-a27c-86bd80044b28" -->
                <v-col cols="12">
                  <v-textarea
                    v-model="quoteNote"
                    label="Quote Note (added to the quote email)"
                    outlined
                    auto-grow
                    rows="2"
                    class="mb-4"
                    hide-details="auto"
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="editedItem.orderProducts"
                    @change="updateOrderProducts"
                    :items="productSelectArray"
                    item-text="title"
                    item-value="id"
                    :label="`${$i18n.t('headings.products')}*`"
                    return-object
                    required
                    :rules="formRules.products"
                    :loading="!syncedProducts || !syncedProductBundles"
                    chips
                    clearable
                    deletable-chips
                    multiple
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12">
                  <div v-if="editedItemProductsWithAddons.length > 0">
                    <v-card-title class="pt-0 pl-0" style="margin-left: -12px">
                      <span class="text-h5">Addons</span>
                    </v-card-title>

                    <div class="mt-4">
                      <div
                        v-for="(
                          product, pIndex
                        ) in editedItemProductsWithAddons"
                        :key="pIndex"
                      >
                        <v-select
                          v-if="getAvailableAddons(product.id).length > 0"
                          v-model="product.addons"
                          :items="getAvailableAddons(product.id)"
                          item-text="title"
                          return-object
                          multiple
                          :label="`Select Addons for ${product.title}`"
                          chips
                          deletable-chips
                        >
                          <template v-slot:selection="{ item }">
                            <v-chip
                              class="ma-1"
                              :input-value="true"
                              close
                              @click:close="
                                removeAddonFromProduct(product, item)
                              "
                            >
                              {{ item.title }} ({{ item.type }}) - R{{
                                item.price.toFixed(2)
                              }}
                            </v-chip>
                          </template>
                          <template v-slot:item="{ item }">
                            {{ item.title }} ({{ item.type }}) - R{{
                              item.price.toFixed(2)
                            }}
                          </template>
                        </v-select>
                      </div>
                    </div>
                  </div>
                </v-col>

                <!-- <v-col cols="12">
                  <v-select
                    v-model="editedItem.orderPaymentMethod"
                    :items="paymentMethods"
                    item-text="title"
                    item-value="value"
                    :label="`${$i18n.t('products.paymentMethod')}*`"
                    :rules="formRules.paymentMethod"
                    readonly
                    required
                  ></v-select>
                </v-col> -->
                <v-col cols="12">
                  <div class="d-flex flex-row align-center" style="gap: 12px">
                    <v-text-field
                      v-model="couponCode"
                      :label="`${$i18n.t('labels.couponCode')}`"
                      :error-messages="couponVerifyErrors"
                      @keyup.enter="verifyCoupon"
                      @input="onCouponCodeInput"
                    ></v-text-field>

                    <v-icon
                      v-if="
                        editedItem.coupon &&
                        editedItem.coupon.couponCode === couponCode
                      "
                      color="primary"
                      >mdi-check</v-icon
                    >

                    <v-btn
                      color="primary"
                      v-else
                      :disabled="
                        verifyingCoupon || !couponCode || couponCode === ''
                      "
                      :loading="verifyingCoupon"
                      @click="verifyCoupon"
                      >{{ $i18n.t("actions.verify") }}</v-btn
                    >
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  v-show="editedItem.orderProducts?.length > 0"
                  style="font-size: 1.3rem; line-height: 1.5"
                >
                  <v-row no-gutters>
                    {{
                      $i18n.t("headings.products") +
                      " (" +
                      $i18n.t("labels.downloadable") +
                      ")"
                    }}: <v-spacer></v-spacer>

                    R{{ editedItemNonPhysicalProductsPrice.toFixed(2) }}
                  </v-row>

                  <v-row no-gutters>
                    {{
                      $i18n.t("headings.products") +
                      " (" +
                      $i18n.t("headings.shipping") +
                      ")"
                    }}: <v-spacer></v-spacer> R{{
                      editedItemPhysicalProductsPrice.toFixed(2)
                    }}
                  </v-row>

                  <v-row
                    no-gutters
                    v-show="editedItemPhysicalProducts?.length > 0"
                  >
                    {{ $i18n.t("headings.shippingFee") }}:
                    <v-spacer></v-spacer> R
                    {{ (130).toFixed(2) }}
                  </v-row>

                  <v-row no-gutters v-show="editedItem.coupon">
                    {{ $i18n.t("labels.coupon") }}: <v-spacer></v-spacer> -R{{
                      editedItemDiscountAmount.toFixed(2)
                    }}
                  </v-row>

                  <v-row no-gutters>
                    {{
                      $i18n.t("labels.subTotal") +
                      " (" +
                      $i18n.t("labels.vatIncluded") +
                      ")"
                    }}: <v-spacer></v-spacer> R
                    {{ editedItemSubTotal.toFixed(2) }}
                  </v-row>
                  <v-row no-gutters>
                    {{
                      $i18n.t("labels.total") +
                      " (" +
                      $i18n.t("labels.vatExcluded") +
                      ")"
                    }}: <v-spacer></v-spacer> R
                    {{ editedItemExclVAT.toFixed(2) }}
                  </v-row>
                  <v-row no-gutters>
                    {{ $i18n.t("labels.vat") }} ( 15% ): <v-spacer></v-spacer> R
                    {{ editedItemTotalVat.toFixed(2) }}
                  </v-row>
                  <v-row no-gutters>
                    {{ $i18n.t("labels.total") }}: <v-spacer></v-spacer> R
                    {{ editedItemSubTotal.toFixed(2) }}
                  </v-row>
                </v-col>
                <!-- <v-col cols="12" v-show="editedItem.orderPaymentMethod === 'EFT'">
                <v-card class="pa-3">
                  <span class="mb-0 text-subtitle-1"><strong>Bank Details:</strong></span>
                  <p class="mb-0">Account holder: A Dempers</p>
                  <p class="mb-0">Account number: 1216434069</p>
                  <p class="mb-0">Account type: Lopende rekening (Current account)</p>
                  <p class="mb-0">Bank name: Nedbank</p>
                  <p class="mb-0">Branch code: 198765</p>
                  <p class="mb-0">Reference: Your Name</p>
                  <p class="mb-0">Proof of payment: info@juffrouanri.com / +27 60 529 4868</p>
                    <p class="mb-0">
Please email a bank-generated PDF proof of payment (screenshots are not accepted), so that your order can be verified and released.
                    </p>
                </v-card>
              </v-col> -->
              </v-row>
            </v-container>
          </v-card-text>
          <div v-if="editedItemProductsQuestions?.length > 0">
            <v-card-title class="pt-0">
              <span class="text-h5">Questions</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <div
                  v-for="(
                    productWithQuestions, productWithQuestionsIndex
                  ) in editedItemProductsQuestions"
                  :key="productWithQuestionsIndex"
                >
                  <span class="text-h6">{{ productWithQuestions.title }}</span>

                  <v-row>
                    <v-col cols="12">
                      <template
                        v-for="(
                          question, questionIndex
                        ) in productWithQuestions.questions"
                      >
                        <v-text-field
                          v-if="question.type === 'Text'"
                          :key="'text-' + questionIndex"
                          v-model="question.value"
                          :label="question.label"
                          :hint="question.hint"
                          :placeholder="question.placeholder"
                          @dblclick="copyPlaceholderToValue(question)"
                          :required="question.required"
                          :rules="question.required ? formRules.required : []"
                        ></v-text-field>
                        <v-textarea
                          v-if="question.type === 'Textarea'"
                          :key="'textarea-' + questionIndex"
                          v-model="question.value"
                          :label="question.label"
                          :hint="question.hint"
                          :placeholder="question.placeholder"
                          @dblclick="copyPlaceholderToValue(question)"
                          auto-grow
                          :required="question.required"
                          :rules="question.required ? formRules.required : []"
                        ></v-textarea>
                        <v-select
                          v-if="
                            question.type === 'Select' ||
                            question.type === 'Multi Select'
                          "
                          :key="'select-' + questionIndex"
                          v-model="question.value"
                          :label="question.label"
                          :items="question.items"
                          :hint="question.hint"
                          :placeholder="question.placeholder"
                          :multiple="question.type === 'Multi Select'"
                          :required="question.required"
                          :rules="question.required ? formRules.required : []"
                        ></v-select>
                        <v-radio-group
                          v-if="question.type === 'Radio'"
                          :key="'radio-' + questionIndex"
                          v-model="question.value"
                          :label="question.label"
                          :hint="question.hint"
                          :rules="question.required ? formRules.required : []"
                        >
                          <v-radio
                            v-for="(item, itemIndex) in question.items"
                            :key="'item-' + itemIndex"
                            :label="item"
                            :value="item"
                          ></v-radio>
                        </v-radio-group>
                        <div
                          v-if="question.type === 'Checkbox'"
                          :key="'checkbox-container-' + questionIndex"
                        >
                          <span class="v-label">{{ question.label }}</span>
                          <template>
                            <v-checkbox
                              v-for="(item, itemIndex) in question.items"
                              :key="
                                'checkbox-' + questionIndex + '-' + itemIndex
                              "
                              v-model="question.value"
                              :value="item"
                              :label="item"
                              :rules="
                                question.required ? formRules.required : []
                              "
                            ></v-checkbox>
                          </template>
                        </div>
                      </template>
                    </v-col>
                  </v-row>
                </div>
              </v-container>
            </v-card-text>
          </div>

          <div v-if="editedItemPhysicalProducts?.length > 0">
            <v-card-title class="py-0" style="gap: 12px">
              <span class="text-h5">{{
                $i18n.t("headings.shippingInfo")
              }}</span>
              <v-spacer></v-spacer>
              <v-btn
                v-show="
                  isValidOwnerField(decodedRouteParamOwner) &&
                  isAmplifyDataStoreId($route.params.teacherProfileId)
                "
                color="primary"
                @click="fetchTeacherShippingDetails"
                :loading="gettingTeacherShippingDetails"
                :disabled="gettingTeacherShippingDetails || offline"
              >
                Fetch Shipping Details
              </v-btn>
            </v-card-title>

            <div
              v-show="noShippingDetailsFound && !gettingTeacherShippingDetails"
              class="px-4 pt-6"
            >
              <v-alert class="mb-0" type="warning">{{
                $i18n.t("products.noShippingDetailsFound")
              }}</v-alert>
            </div>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="shippingDetails.address1"
                      :label="`${$i18n.t('labels.address')} 1`"
                      :rules="formRules.address1"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="shippingDetails.address2"
                      :label="`${$i18n.t('labels.address')} 2`"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="shippingDetails.city"
                      :label="$i18n.t('labels.city')"
                      :rules="formRules.city"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="shippingDetails.province"
                      :items="provinces"
                      :label="`${$i18n.t('labels.province')}*`"
                      :rules="formRules.province"
                      required
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="shippingDetails.postalCode"
                      :label="$i18n.t('labels.postalCode')"
                      :rules="formRules.postalCode"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="shippingDetails.country"
                      readonly
                      :label="$i18n.t('labels.country')"
                      :rules="formRules.country"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="shippingDetails.phoneNumber"
                      :label="
                        $i18n.t('labels.phone') + ' ' + $i18n.t('labels.number')
                      "
                      :rules="formRules.phoneNumber"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row
                  v-show="shippingChanged || savedShippingDetails"
                  no-gutters
                >
                  <div>
                    {{ $i18n.t("products.saveShipping") }}
                    <v-btn
                      color="green"
                      class="ml-3 white--text"
                      :disabled="
                        !shippingChanged ||
                        savingTeacherShippingDetails ||
                        offline
                      "
                      :loading="savingTeacherShippingDetails"
                      @click="saveTeacherShippingDetails"
                      >{{ $i18n.t("actions.yes") }}</v-btn
                    >
                  </div>

                  <div
                    v-if="savedShippingDetails && !savingTeacherShippingDetails"
                    class="ml-3 d-flex align-center"
                  >
                    <!-- {{ $i18n.t("actions.saved") + "!" }} -->
                    <v-icon color="success" class="slide-x-transition">
                      mdi-check-circle
                    </v-icon>
                  </div>
                </v-row>
              </v-container>
            </v-card-text>
          </div>

          <v-card-actions>
            <v-btn
              color="primary"
              @click="close"
              :disabled="savingProductOrder"
            >
              {{ $i18n.t("actions.close") }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!validCreate || savingProductOrder"
              :loading="savingProductOrder"
              color="primary"
              @click="save"
            >
              Create
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="3000">
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
// import Helper from "@/components/global-components/Helper.vue";
import {
  // DataStore, SortDirection, Predicates,
  API,
  Auth,
} from "aws-amplify";
import AWS from "aws-sdk";
// import {
//   TeacherProductsOrder,
//   Product,
//   ProductBundle,
//   ArchivedTeacherProductsOrder,
// } from "@/models";
import store from "@/store";
// import { reconfigureDatastore } from "@/plugins/datastore/config.js";
import {
  listTeacherProductsOrders,
  teacherProductsOrdersByTeacherprofileID,
  getTeacherProductsOrder,
  listProducts,
  listProductBundles,
  teacherProductsOrdersByOrderStatus,
} from "@/graphql/queries";
import {
  createTeacherProductsOrder,
  updateTeacherProductsOrder,
  deleteTeacherProductsOrder,
} from "@/graphql/mutations";
import {
  onCreateTeacherProductsOrder,
  onUpdateTeacherProductsOrder,
  onDeleteTeacherProductsOrder,
  onCreateProduct,
  onUpdateProduct,
  onDeleteProduct,
  onCreateProductBundle,
  onUpdateProductBundle,
  onDeleteProductBundle,
} from "@/graphql/subscriptions";

export default {
  name: "ProductOrders",
  // components: { Helper },
  data: () => ({
    initiallyLoaded: false,

    gettingTeacherShippingDetails: false,
    savingTeacherShippingDetails: false,
    savedShippingDetails: false,
    noShippingDetailsFound: false,
    dialog: false,
    createDialog: false,
    sortBy: "orderDateTime",
    sortDesc: true,
    headers: [],
    search: "",
    searchQuestionProductOrders: false,
    searchPhysicalProductOrders: false,

    filterStartDate: new Date(new Date().setDate(new Date().getDate() - 7))
      .toISOString()
      .split("T")[0], // 1 week ago
    filterEndDate: new Date().toISOString().split("T")[0],
    filterStatuses: ["QUOTING", "DRAFT"],
    showStartDateMenu: false,
    showEndDateMenu: false,
    debouncedLoadOrders: null,

    editedIndex: -1,
    valid: false,
    validCreate: false,
    savingProductOrder: false,

    couponCode: "",
    verifyingCoupon: false,
    couponVerifyErrors: [],
    // validCoupon: null,

    sendingEmails: {}, // tracks loading per quote ID
    snackbar: false,
    snackbarText: "",
    snackbarColor: "success",
    currentUsername: "",

    editedItem: {
      orderDateTime: "",
      orderID: "",
      orderPayment: null,
      orderPaymentMethod: "",
      orderProducts: [],
      orderShippingDetails: null,
      orderStatus: "",
      orderTotal: 0,
      orderVAT: 0,
      coupon: null,
      owner: "",
      teacherprofileID: "",
    },
    defaultItem: {
      orderDateTime: "",
      orderID: "",
      orderPayment: null,
      orderPaymentMethod: "",
      orderProducts: [],
      orderShippingDetails: null,
      orderStatus: "",
      orderTotal: 0,
      orderVAT: 0,
      coupon: null,
      owner: "",
      teacherprofileID: "",
    },

    syncedShippingDetails: null,
    shippingDetails: {
      address1: "",
      address2: "",
      city: "",
      province: "",
      postalCode: "",
      country: "South Africa",
      phoneNumber: "",
    },
    defaultShippingDetails: {
      address1: "",
      address2: "",
      city: "",
      province: "",
      postalCode: "",
      country: "South Africa",
      phoneNumber: "",
    },

    // productsSubscription: null,
    syncedProductModels: [],
    productModels: [],
    syncedProducts: false,

    syncedProductBundleModels: [],
    productBundleModels: [],
    syncedProductBundles: false,

    checkedRouteActions: false,

    // productOrdersSubscription: null,
    syncedProductOrders: false,
    syncedProductOrderModels: [],
    productOrderModels: [],

    productOrdersSubCreate: null,
    productOrdersSubUpdate: null,
    productOrdersSubDelete: null,
    productsSubCreate: null,
    productsSubUpdate: null,
    productsSubDelete: null,
    productBundlesSubCreate: null,
    productBundlesSubUpdate: null,
    productBundlesSubDelete: null,

    eftStatuses: [
      "QUOTING",
      // , "PROCESSING"
      "PAID",
      "CANCELLED",
      "DECLINED",
      "DRAFT",
    ],

    paymentMethods: [
      { title: "EFT", value: "EFT" },
      { title: "Free", value: "Free" },
      { title: "Card Payment", value: "Payfast" },
    ],

    provinces: [
      "Eastern Cape",
      "Free State",
      "Gauteng",
      "KwaZulu-Natal",
      "Limpopo",
      "Mpumalanga",
      "Northern Cape",
      "North West",
      "Western Cape",
    ],

    formRules: {
      required: [(v) => !!v || "This field is required"],
      paymentMethod: [(v) => !!v || "a Payment Method is required"],
      products: [(v) => (!!v && v.length > 0) || "Products are required"],
      address1: [(v) => !!v || "Address is required"],
      city: [(v) => !!v || "City is required"],
      province: [(v) => !!v || "Province is required"],
      postalCode: [(v) => !!v || "Postal code is required"],
      country: [(v) => !!v || "Country is required"],
      phoneNumber: [
        (v) => !!v || "Phone number is required",
        (v) =>
          /^(?:\+27|0)\s?\d{2}\s?\d{3}\s?\d{4}$/.test(v) ||
          "Invalid South African phone number",
      ],
    },
  }),

  computed: {
    ...mapState({
      offline: (state) => !state.isOnline,
      userSignedIn: (state) => state.userSignedIn,
      changingDatastoreConfig: (state) => state.changingDatastoreConfig,
      datastoreReady: (state) => state.datastoreReady,
      startedDatastoreSync: (state) => state.startedDatastoreSync,
    }),

    authMode() {
      return this.userSignedIn ? "AMAZON_COGNITO_USER_POOLS" : "AWS_IAM";
    },

    quoteNote: {
      get() {
        const prefix = "QUOTENOTE: ";
        const notes = Array.isArray(this.editedItem.notes)
          ? this.editedItem.notes
          : [];
        const existing = notes.find(
          (n) => n && typeof n.note === "string" && n.note.startsWith(prefix),
        );
        return existing ? existing.note.slice(prefix.length) : "";
      },
      set(val) {
        const prefix = "QUOTENOTE: ";
        const notes = Array.isArray(this.editedItem.notes)
          ? [...this.editedItem.notes]
          : [];
        const idx = notes.findIndex(
          (n) => n && typeof n.note === "string" && n.note.startsWith(prefix),
        );
        const text = val || "";

        if (text.trim() === "") {
          // cleared -> remove the quote note (leave any other notes intact)
          if (idx !== -1) notes.splice(idx, 1);
        } else {
          const noteObj = {
            note: prefix + text,
            timestamp: new Date().toISOString(),
            username: this.currentUsername || "",
          };
          if (idx !== -1) {
            // keep original timestamp/username when just editing text
            noteObj.timestamp = notes[idx].timestamp || noteObj.timestamp;
            noteObj.username = notes[idx].username || noteObj.username;
            notes.splice(idx, 1, noteObj);
          } else {
            notes.push(noteObj);
          }
        }
        this.$set(this.editedItem, "notes", notes);
      },
    },

    editedItemProductsWithAddons() {
      return (
        this.editedItem.orderProducts?.filter(
          (product) => this.getAvailableAddons(product.id).length > 0,
        ) || []
      );
    },

    decodedRouteParamOwner() {
      return decodeURIComponent(this.$route.params.owner || "");
    },

    orderFieldsEditable() {
      return (
        this.editedIndex !== -1 &&
        this.editedItem.orderStatus !== "PAID" &&
        this.editedItem.orderStatus !== "CANCELLED" &&
        this.editedItem.orderStatus !== "DECLINED"
      );
    },

    productSelectArray() {
      //sort via title
      return [...this.productModels, ...this.productBundleModels].sort(
        (a, b) => {
          if (!a || !b) return 0;
          return (a.title || "").localeCompare(b.title || "");
        },
      );
    },

    filteredOrders() {
      let orders = [...this.productOrderModels];

      // Search filter (adjust fields if you search more)
      if (this.search) {
        const lowerCaseSearch = this.search.toLowerCase();
        orders = orders.filter((order) => {
          const orderStr = `${order.orderID} ${order.owner} ${
            order.orderStatus
          } ${order.orderPaymentMethod} ${
            order.orderProducts?.map((p) => p.id || "").join(" ") || ""
          }`.toLowerCase();
          if (orderStr.includes(lowerCaseSearch)) {
            return true;
          }
        });
      }

      // Physical & Questions checkboxes
      if (this.searchPhysicalProductOrders) {
        orders = orders.filter((order) =>
          this.syncedPOIDsWithPhysical.includes(order.id),
        );
      }
      if (this.searchQuestionProductOrders) {
        orders = orders.filter((order) =>
          this.syncedPOIDsWithQuestions.includes(order.id),
        );
      }

      // const hasCustomFilter =
      //   this.filterStartDate ||
      //   this.filterEndDate ||
      //   this.filterStatuses.length > 0;

      const startDate = this.filterStartDate;

      const nextEndDay = new Date(this.filterEndDate);
      nextEndDay.setDate(nextEndDay.getDate() + 1);

      const endDate = nextEndDay.toISOString().split("T")[0];

      // console.log("Filtering orders with:", {
      //   filterStartDate: this.filterStartDate,
      //   filterEndDate: this.filterEndDate,
      //   startDate,
      //   endDate,
      //   filterStatuses: this.filterStatuses,
      // });

      // if (hasCustomFilter) {
      // User-defined filters
      orders = orders.filter((order) => {
        // Status
        if (
          order.orderStatus === "PENDING" ||
          (this.filterStatuses.length > 0 &&
            !this.filterStatuses.includes(order.orderStatus))
        ) {
          return false;
        }
        // Date range
        const orderUpdatedAt = order.updatedAt.split("T")[0];

        if (startDate) {
          if (orderUpdatedAt < startDate) return false;
        }
        if (endDate) {
          if (orderUpdatedAt > endDate) return false;
        }
        return true;
      });
      // }
      //  else {
      //   // Default view: last 24 hours OR PROCESSING in last month
      //   const lastDayStart = new Date(Date.now() - 24 * 60 * 60 * 1000);
      //   const lastMonthStart = new Date();
      //   lastMonthStart.setMonth(lastMonthStart.getMonth() - 1);

      //   orders = orders.filter((order) => {
      //     const orderDate = new Date(order.orderDateTime);
      //     const isLastDay = orderDate >= lastDayStart;
      //     const isProcessingLastMonth =
      //       order.orderStatus === "PROCESSING" &&
      //       new Date(order.createdAt) >= lastMonthStart;
      //     return isLastDay || isProcessingLastMonth;
      //   });
      // }

      return orders;
    },

    nonPendingOrders() {
      const nonPending =
        this.productOrderModels?.filter((order) => {
          const notPending = order.orderStatus !== "PENDING";

          const physicalOrNot = this.searchPhysicalProductOrders
            ? order.orderProducts?.some((product) => product.physical)
            : true;
          const questionsOrNot = this.searchQuestionProductOrders
            ? order.orderProducts?.some(
                (product) =>
                  Array.isArray(product.questions) &&
                  product.questions.length > 0,
              )
            : true;

          return notPending && physicalOrNot && questionsOrNot;
        }) || [];

      return nonPending;
    },

    formTitle() {
      return this.editedIndex === -1
        ? "View Product Quote"
        : "Edit Product Quote";
    },

    unsavedChanges() {
      const productShippingChanged =
        this.editedItemPhysicalProducts?.length > 0
          ? JSON.stringify(this.editedItem.orderShippingDetails) !==
            JSON.stringify(this.shippingDetails)
          : false;

      return (
        JSON.stringify(
          _.find(this.syncedProductOrderModels, { id: this.editedItem.id }),
        ) !== JSON.stringify(this.editedItem) || productShippingChanged
      );
    },

    shippingChanged() {
      if (this.validCreate || this.valid) {
        const unchanged =
          JSON.stringify(this.syncedShippingDetails) ===
          JSON.stringify(this.shippingDetails);

        return unchanged ? false : true;
      } else {
        return false;
      }
    },

    editedItemPhysicalProducts() {
      return (
        this.editedItem.orderProducts?.filter(
          (product) => product.physical === true,
        ) || []
      );
    },

    editedItemProductsQuestions() {
      return (
        this.editedItem.orderProducts?.filter(
          (product) =>
            Array.isArray(product.questions) && product.questions.length > 0,
        ) || []
      );
    },

    editedItemPhysicalProductsPrice() {
      if (this.editedItemPhysicalProducts.length === 0) return 0;

      let price = 0;

      for (let product of this.editedItemPhysicalProducts) {
        price +=
          product.price && product.discountPercentage
            ? product.price - product.price * (product.discountPercentage / 100)
            : product.price;
      }

      const finalPrice = price < 0 ? 0 : price;

      return finalPrice;
    },

    editedItemNonPhysicalProductsPrice() {
      if (
        !this.editedItem.orderProducts ||
        this.editedItem.orderProducts.length === 0
      )
        return 0;

      let price = 0;

      for (let product of this.editedItem.orderProducts) {
        if (product.physical) continue;

        price +=
          product.price && product.discountPercentage
            ? product.price - product.price * (product.discountPercentage / 100)
            : product.price;
      }

      const finalPrice = price < 0 ? 0 : price;

      return finalPrice;
    },

    editedItemProductsPriceWithCoupon() {
      if (
        !this.editedItem.orderProducts ||
        this.editedItem.orderProducts.length === 0
      )
        return 0;

      let price = 0;

      for (let product of this.editedItem.orderProducts) {
        if (product.physical) continue;

        price +=
          product.price && product.discountPercentage
            ? product.price - product.price * (product.discountPercentage / 100)
            : product.price;
      }

      const coupon = this.editedItem.coupon;
      if (coupon) {
        const percentageType = coupon.discount.type === "PERCENTAGE";

        price = percentageType
          ? price - price * (coupon.discount.value / 100)
          : price - coupon.discount.value;
      }

      const finalPrice = price < 0 ? 0 : price;

      return finalPrice;
    },

    editedItemAddonsTotal() {
      let total = 0;
      if (!this.editedItem.orderProducts) return total;
      for (let product of this.editedItem.orderProducts) {
        if (!product.addons || !Array.isArray(product.addons)) continue;
        for (let addon of product.addons) {
          total += addon.price || 0;
        }
      }
      return total;
    },

    editedItemDiscountableTotal() {
      return (
        this.editedItemNonPhysicalProductsPrice +
        this.editedItemPhysicalProductsPrice +
        this.editedItemAddonsTotal
      );
    },

    editedItemDiscountedTotal() {
      let price = this.editedItemDiscountableTotal;
      // console.log("editedItemDiscountableTotal", price);
      // console.log("editedItem.coupon", this.editedItem.coupon);
      if (this.editedItem.coupon) {
        const discount = this.editedItem.coupon.discount;
        if (discount.type === "PERCENTAGE") {
          price *= 1 - discount.value / 100;
        } else {
          price -= discount.value;
          if (price < 0) price = 0;
        }
      }
      return price;
    },

    editedItemDiscountAmount() {
      return this.editedItemDiscountableTotal - this.editedItemDiscountedTotal;
    },

    editedItemSubTotal() {
      let subTotal = this.editedItemDiscountedTotal;
      if (this.editedItemPhysicalProducts.length > 0) subTotal += 130;
      return subTotal;
    },

    editedItemExclVAT() {
      return this.editedItemSubTotal
        ? Number.parseFloat(this.editedItemSubTotal / (1 + 0.15))
        : 0;
    },

    editedItemTotalVat() {
      return this.editedItemSubTotal
        ? Number.parseFloat(
            (this.editedItemSubTotal / (1 + 0.15) - this.editedItemSubTotal) *
              -1,
          )
        : 0;
    },
  },

  async mounted() {
    try {
      this.debouncedLoadOrders = _.debounce(this.loadOrders, 800);

      try {
        const user = await Auth.currentAuthenticatedUser();
        this.currentUsername = user ? user.username : "";
      } catch (e) {
        this.currentUsername = "";
      }

      // store.commit("changeDatastorePredicates", [
      //   {
      //     model: "TeacherProductsOrder",
      //     predicate: "Admin",
      //   },
      //   {
      //     model: "Product",
      //     predicate: "Admin",
      //   },
      //   {
      //     model: "ProductBundle",
      //     predicate: "Admin",
      //   },
      // ]);

      // if (!this.startedDatastoreSync || this.datastoreReady) {
      //   reconfigureDatastore();
      // }

      // this.functions wont work in data because it this.something refers to something else withing data and not for example a method.
      this.headers = [
        { text: "Quote #", value: "orderID", groupable: false },
        { text: "Date", value: "orderDateTime", groupable: false },
        { text: "User", value: "owner" },
        { text: "Status", value: "orderStatus" },
        { text: "Payment Method", value: "orderPaymentMethod" },
        { text: "Total", value: "orderTotal", groupable: false },
        { text: "Products Count", value: "orderProducts", groupable: false },
        {
          text: this.$i18n.t("labels.actions"),
          value: "actions",
          sortable: false,
          groupable: false,
        },
      ];

      // if (!this.changingDatastoreConfig) {
      this.syncProductOrders();
      this.syncProducts();
      this.syncProductBundles();
      // }
    } catch (error) {
      console.log(error);
    }
    // finally {
    //   if (!this.initiallyLoaded) {
    //     this.initiallyLoaded = true;
    //   }
    // }
  },

  watch: {
    filterStartDate(val) {
      if (val) {
        this.debouncedLoadOrders();
      }
    },

    filterEndDate(val) {
      if (val) {
        this.debouncedLoadOrders();
      }
    },

    filterStatuses: {
      handler() {
        this.debouncedLoadOrders();
      },
      deep: true,
    },

    // changingDatastoreConfig: {
    //   async handler(newVal, oldVal) {
    //     // console.log("watch changingDatastoreConfig", newVal, oldVal);

    //     if (newVal === true) {
    //       return;
    //     }

    //     if (newVal === false) {
    //       this.syncProductOrders();
    //       this.syncProducts();
    //       this.syncProductBundles();
    //     }
    //   },
    // },

    dialog(val) {
      val || this.close();
    },

    createDialog(val) {
      val || this.close();
    },

    "$route.params": {
      handler(newVal, oldVal) {
        // console.log("newVal", newVal);
        // console.log("oldVal", oldVal);

        // if (typeof newVal !== "object") return;

        const { orderId, teacherProfileId, owner, action } = newVal;
        const newValExists =
          orderId || teacherProfileId || owner ? true : false;

        if (newValExists && typeof oldVal !== "object") {
          // Redirect if owner and teacherProfileId are invalid
          if (
            owner &&
            teacherProfileId &&
            (!this.isAmplifyDataStoreId(teacherProfileId) ||
              !this.isValidOwnerField(owner))
          ) {
            return this.$router.push({ path: "/admin/productorders" });
          }

          // Ensure data is available before proceeding
          if (
            this.initiallyLoaded ||
            !this.syncedProductOrders ||
            this.syncedProductOrderModels.length === 0
          ) {
            return;
          }

          if (typeof orderId === "string") {
            const order = _.find(this.syncedProductOrderModels, {
              orderID: orderId,
            });
            if (order) return this.viewItem(order);
          }

          if (this.isAmplifyDataStoreId(teacherProfileId)) {
            this.productOrderModels = this.syncedProductOrderModels.filter(
              (item) => item.teacherprofileID === teacherProfileId,
            );

            if (
              this.isValidOwnerField(owner) &&
              action === "new"
              //  &&
              // this.nonPendingOrders?.length === 0
            ) {
              this.initiallyLoaded = true;
              this.createItem();
            } else if (this.syncedProductOrderModels?.length > 0) {
              this.initiallyLoaded = true;
            }
          }
        } else if (!newValExists && typeof oldVal === "object") {
          this.productOrderModels = [...this.syncedProductOrderModels]; // Shallow copy
        }
      },
      immediate: true,
    },

    // syncedProductOrderModels: {
    //   handler(val) {
    //     if (val?.length > 0) {
    //       if (typeof this.$route.params.orderId === "string") {
    //         const order = _.find(val, { orderID: this.$route.params.orderId });
    //         if (order) {
    //           this.viewItem(order);
    //         }
    //       } else if (
    //         typeof this.$route.params.action === "string" &&
    //         this.$route.params.action === "new"
    //       ) {
    //         this.createItem();
    //       }
    //     }
    //   },
    //   immediate: true,
    // },
  },

  methods: {
    getRecentMonths(count) {
      const months = [];
      let current = new Date();
      for (let i = 0; i < count; i++) {
        const year = current.getFullYear();
        const month = String(current.getMonth() + 1).padStart(2, "0");
        months.push(`${year}-${month}`);
        current.setMonth(current.getMonth() - 1);
      }
      console.log("getRecentMonths:", months);
      return months;
    },

    getMonthsInRange(startStr, endStr) {
      const months = [];
      const start = startStr ? new Date(startStr) : new Date("2000-01-01");
      const end = endStr ? new Date(endStr) : new Date();
      let current = new Date(start.getFullYear(), start.getMonth(), 1);
      const endMonthDate = new Date(end.getFullYear(), end.getMonth() + 1, 0);
      while (current <= endMonthDate) {
        const year = current.getFullYear();
        const month = String(current.getMonth() + 1).padStart(2, "0");
        months.push(`${year}-${month}`);
        current.setMonth(current.getMonth() + 1);
      }
      return months;
    },

    async loadOrders() {
      if (this.offline) return;

      const isTeacherView = this.isAmplifyDataStoreId(
        this.$route.params.teacherProfileId,
      );

      let fetchedItems = [];

      const startDate = new Date(this.filterStartDate).toISOString();

      const nextEndDay = new Date(this.filterEndDate);
      nextEndDay.setDate(nextEndDay.getDate() + 1);

      const endDate = nextEndDay.toISOString();

      console.log("Filtering orders with:", {
        filterStartDate: this.filterStartDate,
        filterEndDate: this.filterEndDate,
        filterStatuses: this.filterStatuses,
        startDate,
        endDate,
      });

      if (isTeacherView) {
        if (this.syncedProductOrders) return; // already fully loaded for teacher
        const teacherId = this.$route.params.teacherProfileId;
        try {
          const items = await this.fetchAllWithGSI(
            teacherProductsOrdersByTeacherprofileID,
            "teacherProductsOrdersByTeacherprofileID",
            {
              teacherprofileID: teacherId,
            },
          );
          fetchedItems = items || [];
        } catch (e) {
          console.warn("Failed to load teacher orders", e);
        }
      } else {
        this.syncedProductOrders = false;

        // Admin view - dynamic loading based on filters
        const selectedStatuses =
          this.filterStatuses.length > 0 ? this.filterStatuses : null;

        const monthsInRange = this.getMonthsInRange(startDate, endDate);

        console.log("monthsInRange to fetch:", monthsInRange);

        // if (selectedStatuses) {
        // Query only selected statuses
        for (const status of selectedStatuses) {
          // for (const month of updatedMonths) {
          try {
            const items = await this.fetchAllWithGSI(
              teacherProductsOrdersByOrderStatus,
              "teacherProductsOrdersByOrderStatus",
              {
                orderStatus: status,
                updatedAt: {
                  between: [startDate, endDate],
                },
              },
            );
            fetchedItems = fetchedItems.concat(items || []);
          } catch (e) {
            console.warn("Error fetching orders by status:", e);
          }
        }
        // } else {
        //   // No status filter
        //   // UpdatedAtMonth - always all statuses
        //   for (const month of monthsInRange) {
        //     try {
        //       const items = await this.fetchAllWithGSI(
        //         teacherProductsOrdersByUpdatedAtMonth,
        //         "teacherProductsOrdersByUpdatedAtMonth",
        //         {
        //           updatedAtMonth: month,
        //           updatedAt: {
        //             between: [startDate, endDate],
        //           },
        //           filter: { orderStatus: { ne: "QUOTING" } },
        //         },
        //       );
        //       fetchedItems = fetchedItems.concat(items || []);
        //     } catch (e) {
        //       console.warn("Error fetching orders by updatedAtMonth:", e);
        //     }
        //   }
        // }

        // Deduplicate
        const seen = new Set();
        fetchedItems = fetchedItems.filter((item) => {
          if (!item?.id || seen.has(item.id)) return false;
          seen.add(item.id);
          return true;
        });
      }

      // Add only new items to the master list
      const currentIds = new Set(
        this.syncedProductOrderModels.map((o) => o.id),
      );
      const newItems = fetchedItems.filter((item) => !currentIds.has(item.id));

      if (newItems.length > 0 || this.syncedProductOrderModels.length === 0) {
        const combined = [...this.syncedProductOrderModels, ...newItems];
        this.handleProductOrdersUpdate(combined);
      }
    },

    async fetchAllWithGSI(query, queryName, variables = {}) {
      try {
        let items = [];
        let nextToken = null;

        do {
          const response = await API.graphql({
            query: query,
            variables: {
              ...variables,
              filter: {
                ...variables.filter,
                _deleted: { ne: true },
              },
              nextToken,
              limit: 4000,
            },
            authMode: this.authMode,
          });

          if (!response || !response.data) break;
          const page = response.data[queryName];
          const newItems = page?.items?.filter(Boolean) || [];
          items = items.concat(newItems);
          nextToken = page?.nextToken;
        } while (nextToken);

        items = this.parseGraphqlResult(items);

        // console.log(`Fetched ${items.length}: ${items} from ${queryName}`);

        return items;
      } catch (error) {
        console.error(`Error fetching items from ${queryName}:`, error);
        return [];
      }
    },

    async fetchAll(query, queryName, variables = {}) {
      try {
        let items = [];
        let nextToken = null;
        do {
          const res = await API.graphql({
            query,
            variables: {
              ...variables,
              filter: {
                ...variables.filter,
                _deleted: { ne: true },
              },
              nextToken,
              limit: 4000,
            },
            authMode: this.authMode,
          }).catch((error) => {
            console.error(`Error executing GraphQL query ${queryName}:`, error);
            return error || null;
          });

          console.log(`result from ${queryName}:`, res);
          if (!res || !res.data) break;

          const page = res.data[queryName];
          const newItems = page?.items?.filter(Boolean) || [];

          items = items.concat(newItems);
          nextToken = res.data[queryName].nextToken;
        } while (nextToken);

        items = this.parseGraphqlResult(items);

        // console.log(`Fetched ${items.length} items from ${queryName}`);

        return items;
      } catch (error) {
        console.error(`Error fetching items from ${queryName}:`, error);
        return [];
      }
    },

    // getRecentMonths(howMany = 8) {
    //   const months = [];
    //   const now = new Date();
    //   for (let i = 0; i < howMany; i++) {
    //     const d = new Date(now.getFullYear(), now.getMonth() + 1 - i, 1);
    //     months.push(d.toISOString().slice(0, 7)); // "2026-01"
    //   }
    //   // console.log("Recent months:", months);
    //   return months; // newest → oldest
    // },

    parseGraphqlResult(data) {
      if (data === null || data === undefined) return data;

      // If it's an array, map over it recursively
      if (Array.isArray(data)) {
        return data.map(this.parseGraphqlResult);
      }

      // If it's an object, iterate keys
      if (typeof data === "object") {
        const parsedObject = {};
        for (const [key, value] of Object.entries(data)) {
          parsedObject[key] = this.parseGraphqlResult(value);
        }
        return parsedObject;
      }

      // If it's a string, try to parse it
      if (typeof data === "string") {
        try {
          // Basic check to avoid parsing simple strings like "Hello"
          // Only parse if it starts with { or [
          const trimmed = data.trim();
          if (
            (trimmed.startsWith("{") && trimmed.endsWith("}")) ||
            (trimmed.startsWith("[") && trimmed.endsWith("]"))
          ) {
            return JSON.parse(data);
          }
        } catch (e) {
          // If parsing fails, just return the original string
          return data;
        }
      }

      return data;
    },

    async handleProductOrdersUpdate(items, isSynced = true) {
      if (items) {
        this.syncedProductOrderModels = items;

        // productOrder ids that contain product with questions
        this.syncedPOIDsWithQuestions = items
          .filter((item) =>
            item.orderProducts?.some(
              (product) =>
                Array.isArray(product.questions) &&
                product.questions.length > 0,
            ),
          )
          .map((item) => item.id);

        // productOrder ids that contain product that's physical
        this.syncedPOIDsWithPhysical = items
          .filter((item) =>
            item.orderProducts?.some((product) => product.physical === true),
          )
          .map((item) => item.id);

        const isValidTeacherProfileId = this.isAmplifyDataStoreId(
          this.$route.params.teacherProfileId,
        );

        if (isValidTeacherProfileId) {
          this.productOrderModels = _.filter(
            items,
            (item) =>
              item.teacherprofileID === this.$route.params.teacherProfileId,
          );
        } else {
          this.productOrderModels = _.cloneDeep(items);
        }

        // Handle route params logic
        if (typeof this.$route.params === "object") {
          if (typeof this.$route.params.orderId === "string") {
            const order = _.find(items, {
              orderID: this.$route.params.orderId,
            });
            if (order) {
              this.viewItem(order);
            }
          }
          // else if (
          //   this.isValidOwnerField(this.decodedRouteParamOwner) &&
          //   isValidTeacherProfileId &&
          //   typeof this.$route.params.action === "string" &&
          //   this.$route.params.action === "new"
          // ) {
          //   this.createItem();
          // }
        }
      }

      if (isSynced) {
        this.syncedProductOrders = true;
      } else {
        this.syncedProductOrders = false;
      }
    },

    async handleProductsUpdate(items, isSynced = true) {
      if (items) {
        this.syncedProductModels = items;
        this.productModels = _.cloneDeep(items);
      }

      if (isSynced) {
        this.syncedProducts = true;
      } else {
        this.syncedProducts = false;
      }
    },

    async handleProductBundlesUpdate(items, isSynced = true) {
      if (items) {
        this.syncedProductBundleModels = items;
        this.productBundleModels = _.cloneDeep(items);
      }

      if (isSynced) {
        this.syncedProductBundles = true;
      } else {
        this.syncedProductBundles = false;
      }
    },

    removeAddonFromProduct(product, addon) {
      const productIndex = this.editedItem.orderProducts.findIndex(
        (p) => p.id === product.id,
      );
      console.log("productIndex", productIndex);
      if (productIndex !== -1) {
        const addonIndex = this.editedItem.orderProducts[productIndex].addons
          ? this.editedItem.orderProducts[productIndex].addons.findIndex(
              (a) => a.title === addon.title && a.type === addon.type,
            )
          : -1;
        console.log("addonIndex", addonIndex);
        if (addonIndex !== -1) {
          this.editedItem.orderProducts[productIndex].addons.splice(
            addonIndex,
            1,
          );
        }
      }
    },

    getAvailableAddons(productId) {
      const originalProduct = [
        ...this.syncedProductModels,
        ...this.syncedProductBundleModels,
      ].find((p) => p.id === productId);
      return originalProduct?.addons || [];
    },

    customSort(items, sortBy, sortDesc) {
      return items.slice().sort((a, b) => {
        for (let i = 0; i < sortBy.length; i++) {
          const key = sortBy[i];
          const isDescending = sortDesc[i] ? -1 : 1;

          // ✅ Custom sorting logic for specific columns
          if (key === "physical") {
            return (
              (this.syncedPOIDsWithPhysical.includes(b.id) -
                this.syncedPOIDsWithPhysical.includes(a.id)) *
              isDescending
            );
          }

          if (key === "questions") {
            return (
              (this.syncedPOIDsWithQuestions.includes(b.id) -
                this.syncedPOIDsWithQuestions.includes(a.id)) *
              isDescending
            );
          }

          // Default sorting logic
          let aValue = a[key];
          let bValue = b[key];

          // Convert AWS date-time strings to Date objects for proper sorting
          if (key === "orderDateTime") {
            aValue = new Date(aValue);
            bValue = new Date(bValue);
          }

          if (aValue < bValue) return -1 * isDescending;
          if (aValue > bValue) return 1 * isDescending;
        }
        return 0;
      });
    },

    updateOrderStatus(updatedValue) {
      const previousStatus = this.editedItem.orderStatus;
      console.log("previousStatus", previousStatus);
      console.log("updatedValue", updatedValue);

      if (previousStatus === "QUOTING") {
        this.editedItem.orderPaymentMethod = "EFT";
      } else if (
        updatedValue === "QUOTING" &&
        this.editedItem.orderPaymentMethod !== "Payfast"
      ) {
        this.editedItem.orderPaymentMethod = "";
      }

      this.editedItem.orderStatus = updatedValue;
    },

    getCognitoAttributeValue(attributesArray, attrName) {
      if (typeof attributesArray !== "object") return "";
      for (const attribute of attributesArray) {
        if (attribute.Name === attrName) {
          return attribute.Value;
        }
      }
      return "";
    },

    onCouponCodeInput(value) {
      // Convert to uppercase and remove non-alphanumeric characters
      this.couponCode = value
        ? value
            .trim()
            .toUpperCase()
            .replace(/[^A-Z0-9]/g, "")
        : "";
    },

    // couponText(coupon) {
    //   if (coupon) {
    //     return coupon.discount.type === "PERCENTAGE"
    //       ? `- ${coupon.discount.value}%`
    //       : `- R${coupon.discount.value.toFixed(2)}`;
    //   } else {
    //     return "";
    //   }
    // },

    async verifyCoupon() {
      if (this.couponCode === "") {
        this.couponVerifyErrors = ["Coupon code is required"];
        return;
      }

      this.verifyingCoupon = true;
      try {
        await API.get("couponapi", "/item/verifyCoupon", {
          queryStringParameters: {
            teacherProfileID:
              this.$route.params?.teacherProfileId ||
              this.editedItem.teacherprofileID,
            couponCode: this.couponCode,
          },
        })
          .then(async (response) => {
            if (response?.validCoupon) {
              this.couponVerifyErrors = [];
              // this.validCoupon = response.validCoupon;
              this.editedItem.coupon = response.validCoupon;
              console.log(this.validCoupon);
            } else {
              this.couponVerifyErrors = [response.error];
              // this.validCoupon = null;
              this.editedItem.coupon = null;
            }

            this.verifyingCoupon = false;
          })
          .catch((error) => {
            console.log(error);
            this.couponVerifyErrors = [
              "An error occurred while verifying the coupon, please check your internet connection or try again later.",
            ];
            // this.validCoupon = null;
            this.editedItem.coupon = null;

            this.verifyingCoupon = false;
          });
      } catch (error) {
        console.log(error);
      }
    },

    updateOrderProducts() {
      // console.log("updateOrderProducts");
      this.editedItem.orderProducts = this.editedItem.orderProducts.map(
        (product) => _.cloneDeep(product),
      );

      // if (
      //   this.editedItem.orderProducts?.length === 0 ||
      //   this.editedItemSubTotal > 0
      // ) {
      //   this.editedItem.orderPaymentMethod = "EFT";
      // } else if (this.editedItemSubTotal === 0) {
      //   this.editedItem.orderPaymentMethod = "Free";
      // }
    },

    async saveTeacherShippingDetails() {
      try {
        this.savingTeacherShippingDetails = true;
        await API.put("shippingapi", "/item/saveTeacherShippingDetails", {
          body: {
            teacherProfileID: this.$route.params.teacherProfileId,
            shippingDetails: this.shippingDetails,
          },
          // headers: {} // OPTIONAL
        })
          .then(async (response) => {
            if (response.error) {
              console.log(response.error);
            } else if (typeof response.success === "string") {
              // console.log("Shipping details saved successfully");
              this.syncedShippingDetails = _.cloneDeep(this.shippingDetails);
            }
            this.savingTeacherShippingDetails = false;
            this.savedShippingDetails = true;
            setTimeout(() => {
              this.savedShippingDetails = false;
            }, 5000);
          })
          .catch((error) => {
            console.log(error);
            this.savingTeacherShippingDetails = false;
          });
      } catch (error) {
        console.log(error);
        this.savingTeacherShippingDetails = false;
      }
    },

    async fetchTeacherShippingDetails() {
      try {
        this.gettingTeacherShippingDetails = true;
        await API.get("shippingapi", "/item/getTeacherShippingDetails", {
          queryStringParameters: {
            teacherProfileID: this.$route.params.teacherProfileId,
          },
        })
          .then(async (response) => {
            if (response.error) {
              console.log(response.error);
            } else if (typeof response.shippingDetails === "string") {
              this.noShippingDetailsFound = false;
              const responseShippingDetails = JSON.parse(
                response.shippingDetails,
              );
              // this.editedItem.orderShippingDetails = responseShippingDetails;
              this.shippingDetails = _.cloneDeep(responseShippingDetails);
              this.syncedShippingDetails = _.cloneDeep(responseShippingDetails);
            } else {
              // console.log("No shipping details found");
              this.noShippingDetailsFound = true;
              setTimeout(() => {
                this.noShippingDetailsFound = false;
              }, 5000);
            }

            this.gettingTeacherShippingDetails = false;
          })
          .catch((error) => {
            console.log(error);
            this.gettingTeacherShippingDetails = false;

            this.noShippingDetailsFound = true;
            setTimeout(() => {
              this.noShippingDetailsFound = false;
            }, 5000);
          });
      } catch (error) {
        console.log(error);
        this.gettingTeacherShippingDetails = false;

        this.noShippingDetailsFound = true;
        setTimeout(() => {
          this.noShippingDetailsFound = false;
        }, 5000);
      }
    },

    copyPlaceholderToValue(question) {
      if (!question.value && question.placeholder) {
        question.value = question.placeholder;
      }
    },

    async save() {
      this.savingProductOrder = true;
      if (this.editedIndex > -1) {
        // Update Product Order
        await this.updateProductOrder();
      } else {
        // Create new Product Order
        await this.createProductOrder();
      }
      this.close();
      this.savingProductOrder = false;
    },

    async createProductOrder() {
      try {
        const newOrderID = this.generateOrderID();

        const uniqueProducts = _.uniqBy(this.editedItem.orderProducts, "id");
        const newProducts = uniqueProducts.map((obj) => {
          const newObj = { ...obj };

          if (newObj.thumbnailImages) delete newObj.thumbnailImages;
          if (newObj.searchField) delete newObj.searchField;
          if (newObj.description) delete newObj.description;
          if (newObj.displayItems) delete newObj.displayItems;
          if (newObj.createdAt) delete newObj.createdAt;
          if (newObj.updatedAt) delete newObj.updatedAt;
          if (newObj.featured) delete newObj.featured;
          if (newObj.thumbnails) delete newObj.thumbnails;
          if (newObj.type) delete newObj.type;
          if (newObj.videoPreview) delete newObj.videoPreview;
          if (newObj._lastChangedAt) delete newObj._lastChangedAt;
          if (newObj.__typename) delete newObj.__typename;

          return newObj;
        });

        const orderTotal = parseFloat(this.editedItemSubTotal.toFixed(2));
        const orderVAT = parseFloat(this.editedItemTotalVat.toFixed(2));

        const newOrderMonth = new Date().toISOString().slice(0, 7);

        const notesJSON = await this.buildQuoteNotesJSON();

        const input = {
          orderDateTime: new Date().toISOString(),
          orderID: newOrderID,
          orderPaymentMethod:
            this.editedItem.orderPaymentMethod > ""
              ? this.editedItem.orderPaymentMethod
              : null,
          orderProducts: JSON.stringify(newProducts),
          orderTotal: orderTotal,
          orderVAT: orderVAT,
          coupon: this.editedItem.coupon
            ? JSON.stringify(this.editedItem.coupon)
            : null,
          orderShippingDetails:
            this.editedItemPhysicalProducts?.length > 0
              ? JSON.stringify(this.shippingDetails)
              : null,
          orderStatus: "DRAFT",
          notes: notesJSON,
          createdAtMonth: newOrderMonth,
          updatedAtMonth: newOrderMonth,
          owner: this.decodedRouteParamOwner,
          teacherprofileID: this.$route.params.teacherProfileId,
        };

        const newProductOrder = await API.graphql({
          query: createTeacherProductsOrder,
          variables: { input },
          authMode: this.authMode,
        }).then((res) => res.data.createTeacherProductsOrder);

        // await DataStore.save(
        //   TeacherProductsOrder.copyOf(newProductOrder, (updateModel) => {
        //     updateModel.owner = this.decodedRouteParamOwner;
        //   })
        // );
      } catch (error) {
        console.log("Error creating product order:", error);
      }
    },

    async updateProductOrder() {
      try {
        const uniqueProducts = _.uniqBy(this.editedItem.orderProducts, "id");
        const newProducts = uniqueProducts.map((obj) => {
          const newObj = { ...obj };

          if (newObj.thumbnailImages) delete newObj.thumbnailImages;
          if (newObj.searchField) delete newObj.searchField;
          if (newObj.description) delete newObj.description;
          if (newObj.displayItems) delete newObj.displayItems;
          if (newObj.createdAt) delete newObj.createdAt;
          if (newObj.updatedAt) delete newObj.updatedAt;
          if (newObj.featured) delete newObj.featured;
          if (newObj.thumbnails) delete newObj.thumbnails;
          if (newObj.type) delete newObj.type;
          if (newObj.videoPreview) delete newObj.videoPreview;
          if (newObj._lastChangedAt) delete newObj._lastChangedAt;
          if (newObj.__typename) delete newObj.__typename;

          return newObj;
        });

        const orderTotal = parseFloat(this.editedItemSubTotal.toFixed(2));
        const orderVAT = parseFloat(this.editedItemTotalVat.toFixed(2));

        // Fetch current for _version
        const current = await API.graphql({
          query: getTeacherProductsOrder,
          variables: {
            id: this.editedItem.id,
            filter: { _deleted: { ne: true } },
          },
          authMode: this.authMode,
        }).then((res) => res.data.getTeacherProductsOrder);

        console.log("current _version", current._version);
        console.log("this.editedItem _version", this.editedItem._version);

        const notesJSON = await this.buildQuoteNotesJSON();

        await API.graphql({
          query: updateTeacherProductsOrder,
          variables: {
            input: {
              id: this.editedItem.id,
              orderStatus: this.editedItem.orderStatus,
              notes: notesJSON,
              orderProducts: JSON.stringify(newProducts),
              orderTotal: orderTotal,
              orderVAT: orderVAT,
              coupon: this.editedItem.coupon
                ? JSON.stringify(this.editedItem.coupon)
                : null,
              orderShippingDetails:
                this.editedItemPhysicalProducts?.length > 0
                  ? JSON.stringify(this.shippingDetails)
                  : null,
              orderPaymentMethod:
                this.editedItem.orderPaymentMethod > ""
                  ? this.editedItem.orderPaymentMethod
                  : null,
              updatedAtMonth: new Date().toISOString().slice(0, 7),
              _version: this.editedItem._version,
            },
          },
          authMode: this.authMode,
        });
      } catch (error) {
        console.log("Error updating product order:", error);
      }
    },

    // ADD: serialize notes for save (keeps other notes, fills username if missing)
    async buildQuoteNotesJSON() {
      const prefix = "QUOTENOTE: ";
      const notes = Array.isArray(this.editedItem.notes)
        ? this.editedItem.notes
        : [];

      const needsUser = notes.some(
        (n) =>
          n &&
          typeof n.note === "string" &&
          n.note.startsWith(prefix) &&
          !n.username,
      );
      if (needsUser) {
        const user = await Auth.currentAuthenticatedUser().catch(() => {
          // eslint-disable-next-line @typescript-eslint/no-empty-function
        });
        notes.forEach((n) => {
          if (
            n &&
            typeof n.note === "string" &&
            n.note.startsWith(prefix) &&
            !n.username
          ) {
            n.username = user ? user.username : "";
          }
        });
      }

      return notes.length > 0 ? JSON.stringify(notes) : null;
    },

    async sendProductOrderEmail(order) {
      try {
        this.$set(this.sendingEmails, order.id, true);

        const user = await Auth.currentAuthenticatedUser().catch(() => {
          // eslint-disable-next-line @typescript-eslint/no-empty-function
        });
        if (!user) return;

        const response = await API.post(
          "adminlambdaapi",
          "/item/sendProductOrderEmail",
          {
            body: {
              emailType: "QUOTE", // <-- match your lambda's key for quote emails
              order,
              productID: null,
            },
          },
        );

        if (response.success) {
          this.snackbarText = `Quote email sent successfully for ${order.orderID}`;
          this.snackbarColor = "success";
          this.snackbar = true;
        }
      } catch (error) {
        console.error("Error sending quote email:", error);
        this.snackbarText = `Error sending quote email for ${order.orderID}: ${
          error.message || "Unknown error"
        }`;
        this.snackbarColor = "error";
        this.snackbar = true;
      } finally {
        this.$set(this.sendingEmails, order.id, false);
      }
    },

    generateOrderID() {
      const now = new Date();
      const year = now.getFullYear().toString().slice(-2); // Get last 2 digits of year
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const day = now.getDate().toString().padStart(2, "0");
      const hour = now.getHours().toString().padStart(2, "0");
      const minute = now.getMinutes().toString().padStart(2, "0");
      const second = now.getSeconds().toString().padStart(2, "0");
      const millisecond = Math.floor(now.getMilliseconds() / 10)
        .toString()
        .padStart(2, "0");
      return `${year}${month}${day}-${hour}${minute}${second}${millisecond}`;
    },

    isValidOwnerField(owner) {
      // console.log("isValidOwnerField", owner);
      // Regular expression to validate the format cognitoSub::username
      const ownerRegex =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}::[^ ]{1,}$/i;

      // console.log(ownerRegex.test(owner));
      return ownerRegex.test(owner);
    },

    isAmplifyDataStoreId(id) {
      // console.log("isAmplifyDataStoreId", id);
      // Regular expression to check UUID format
      const uuidRegex =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

      // console.log(uuidRegex.test(id));
      return uuidRegex.test(id);
    },

    async syncProductOrders() {
      try {
        console.log("syncProductOrders");
        await this.loadOrders();

        // console.log("syncProductOrders");
        const isValidTeacherProfileId = this.isAmplifyDataStoreId(
          this.$route.params.teacherProfileId,
        );

        // let allItems = [];

        // // ───────────────────────────────────────────────
        // //  Option A: You have teacherprofileID → best performance
        // // ───────────────────────────────────────────────
        // if (isValidTeacherProfileId) {
        //   const teacherId = this.$route.params.teacherProfileId;

        //   try {
        //     const items = await this.fetchAllWithGSI(
        //       teacherProductsOrdersByTeacherprofileID,
        //       "teacherProductsOrdersByTeacherprofileID",
        //       {
        //         teacherprofileID: teacherId,
        //         filter: {
        //           or: [
        //             { orderStatus: { eq: "QUOTING" } },
        //             { orderStatus: { eq: "DRAFT" } },
        //           ],
        //         },
        //       },
        //     );

        //     allItems = allItems.concat(items || []);
        //   } catch (e) {
        //     console.warn(`Failed to fetch for teacher`, e);
        //   }
        // }

        // // ───────────────────────────────────────────────
        // //  Option B: No teacherprofileID → admin view (much heavier)
        // // ───────────────────────────────────────────────
        // else {
        //   try {
        //     let items = await this.fetchAllWithGSI(
        //       teacherProductsOrdersByOrderStatus,
        //       "teacherProductsOrdersByOrderStatus",
        //       {
        //         orderStatus: "QUOTING",
        //       },
        //     );

        //     let items2 = await this.fetchAllWithGSI(
        //       teacherProductsOrdersByOrderStatus,
        //       "teacherProductsOrdersByOrderStatus",
        //       {
        //         orderStatus: "DRAFT",
        //       },
        //     );
        //     allItems = allItems.concat(items || []).concat(items2 || []);
        //   } catch {
        //     console.error(`No items found for orderStatus QUOTING or DRAFT`);
        //   }

        //   // Very important: remove exact duplicates (same id can appear in both GSIs)
        //   const seen = new Set();
        //   allItems = allItems.filter((item) => {
        //     if (seen.has(item.id)) return false;
        //     seen.add(item.id);
        //     return true;
        //   });
        // }

        // // // Final in-memory filtering if you still want to be very close to old logic
        // // const sixMonthsAgo = new Date(
        // //   Date.now() - 6 * 30 * 24 * 60 * 60 * 1000,
        // // );
        // // const oneMonthAgo = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000);

        // // allItems = allItems.filter((order) => {
        // //   const created = new Date(order.createdAt);
        // //   const updated = new Date(order.updatedAt);
        // //   const isRecentUpdate = updated > oneMonthAgo;
        // //   const isRecentProcessing =
        // //     order.orderStatus === "PROCESSING" && created > sixMonthsAgo;
        // //   return isRecentUpdate || isRecentProcessing;
        // // });

        // // console.log(
        // //   `Fetched items for ProductOrders: ${allItems}, typeof ${typeof allItems}`,
        // // );

        // this.handleProductOrdersUpdate(allItems);

        this.productOrdersSubCreate = API.graphql({
          query: onCreateTeacherProductsOrder,
          authMode: this.authMode,
        }).subscribe({
          next: ({ value }) => {
            const created = value.data.onCreateTeacherProductsOrder;
            if (created) {
              if (
                !isValidTeacherProfileId ||
                created.teacherprofileID === this.$route.params.teacherProfileId
              ) {
                const currentItems = this.syncedProductOrderModels || [];
                const newItems = this.parseGraphqlResult([
                  ...currentItems,
                  created,
                ]);
                this.handleProductOrdersUpdate(newItems);
              }
            }
          },
          error: (error) => console.log(error),
        });

        this.productOrdersSubUpdate = API.graphql({
          query: onUpdateTeacherProductsOrder,
          variables: { filter: { _deleted: { ne: true } } },
          authMode: this.authMode,
        }).subscribe({
          next: ({ value }) => {
            const updated = value.data.onUpdateTeacherProductsOrder;
            if (updated) {
              if (
                !isValidTeacherProfileId ||
                updated.teacherprofileID === this.$route.params.teacherProfileId
              ) {
                const currentItems = this.syncedProductOrderModels || [];
                const index = currentItems.findIndex(
                  (i) => i.id === updated.id,
                );
                if (index !== -1) {
                  currentItems[index] = updated;
                  const newItems = this.parseGraphqlResult([...currentItems]);
                  this.handleProductOrdersUpdate(newItems);
                } else if (index === -1) {
                  // If new to this view
                  currentItems.push(updated);
                  const newItems = this.parseGraphqlResult([...currentItems]);
                  this.handleProductOrdersUpdate(newItems);
                }
              }
            }
          },
          error: (error) => console.log(error),
        });

        this.productOrdersSubDelete = API.graphql({
          query: onDeleteTeacherProductsOrder,
          authMode: this.authMode,
        }).subscribe({
          next: ({ value }) => {
            const deleted = value.data.onDeleteTeacherProductsOrder;
            if (deleted) {
              if (
                !isValidTeacherProfileId ||
                deleted.teacherprofileID === this.$route.params.teacherProfileId
              ) {
                const currentItems = this.syncedProductOrderModels || [];
                const newItems = this.parseGraphqlResult(
                  currentItems.filter((i) => i.id !== deleted.id),
                );
                this.handleProductOrdersUpdate(newItems);
              }
            }
          },
          error: (error) => console.log(error),
        });
      } catch (error) {
        console.log(error);
      }
    },

    async syncProducts() {
      try {
        // console.log("syncProducts");
        let items = await this.fetchAll(listProducts, "listProducts");

        for (let item of items) {
          if (!item || !item.id) {
            console.warn("syncProducts - Skipping invalid item:", item);
            continue;
          }
        }

        this.handleProductsUpdate(items);

        this.productsSubCreate = API.graphql({
          query: onCreateProduct,
          authMode: this.authMode,
        }).subscribe({
          next: ({ value }) => {
            const created = value.data.onCreateProduct;
            if (created) {
              const currentItems = this.syncedProductModels || [];
              const newItems = this.parseGraphqlResult([
                ...currentItems,
                created,
              ]);
              this.handleProductsUpdate(newItems);
            }
          },
          error: (error) => console.log(error),
        });

        this.productsSubUpdate = API.graphql({
          query: onUpdateProduct,
          variables: { filter: { _deleted: { ne: true } } },
          authMode: this.authMode,
        }).subscribe({
          next: ({ value }) => {
            const updated = value.data.onUpdateProduct;
            if (updated) {
              const currentItems = this.syncedProductModels || [];
              const index = currentItems.findIndex((i) => i.id === updated.id);
              if (index !== -1) {
                currentItems[index] = updated;
                const newItems = this.parseGraphqlResult([...currentItems]);
                this.handleProductsUpdate(newItems);
              }
            }
          },
          error: (error) => console.log(error),
        });

        this.productsSubDelete = API.graphql({
          query: onDeleteProduct,
          authMode: this.authMode,
        }).subscribe({
          next: ({ value }) => {
            const deleted = value.data.onDeleteProduct;
            if (deleted) {
              const currentItems = this.syncedProductModels || [];
              const newItems = this.parseGraphqlResult(
                currentItems.filter((i) => i.id !== deleted.id),
              );
              this.handleProductsUpdate(newItems);
            }
          },
          error: (error) => console.log(error),
        });
      } catch (error) {
        console.log(error);
      }
    },

    async syncProductBundles() {
      try {
        let items = await this.fetchAll(
          listProductBundles,
          "listProductBundles",
        );

        for (let item of items) {
          if (!item || !item.id) {
            console.warn("syncProductBundles - Skipping invalid item:", item);
            continue;
          }
        }

        this.handleProductBundlesUpdate(items);

        this.productBundlesSubCreate = API.graphql({
          query: onCreateProductBundle,
          authMode: this.authMode,
        }).subscribe({
          next: ({ value }) => {
            const created = value.data.onCreateProductBundle;
            if (created) {
              const currentItems = this.syncedProductBundleModels || [];
              const newItems = this.parseGraphqlResult([
                ...currentItems,
                created,
              ]);
              this.handleProductBundlesUpdate(newItems);
            }
          },
          error: (error) => console.log(error),
        });

        this.productBundlesSubUpdate = API.graphql({
          query: onUpdateProductBundle,
          variables: { filter: { _deleted: { ne: true } } },
          authMode: this.authMode,
        }).subscribe({
          next: ({ value }) => {
            const updated = value.data.onUpdateProductBundle;
            if (updated) {
              const currentItems = this.syncedProductBundleModels || [];
              const index = currentItems.findIndex((i) => i.id === updated.id);
              if (index !== -1) {
                currentItems[index] = updated;
                const newItems = this.parseGraphqlResult([...currentItems]);
                this.handleProductBundlesUpdate(newItems);
              }
            }
          },
          error: (error) => console.log(error),
        });

        this.productBundlesSubDelete = API.graphql({
          query: onDeleteProductBundle,
          authMode: this.authMode,
        }).subscribe({
          next: ({ value }) => {
            const deleted = value.data.onDeleteProductBundle;
            if (deleted) {
              const currentItems = this.syncedProductBundleModels || [];
              const newItems = this.parseGraphqlResult(
                currentItems.filter((i) => i.id !== deleted.id),
              );
              this.handleProductBundlesUpdate(newItems);
            }
          },
          error: (error) => console.log(error),
        });
      } catch (error) {
        console.log(error);
      }
    },

    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleString();
    },

    resetForm() {
      // if (this.$refs.form) this.$refs.form.reset();

      this.editedItem = _.cloneDeep(this.defaultItem);
      this.shippingDetails = _.cloneDeep(this.defaultShippingDetails);
      this.editedIndex = -1;
      // this.validCoupon = null;
      this.couponCode = "";
      this.couponVerifyErrors = [];
      this.verifyingCoupon = false;
      this.valid = false;
      this.validCreate = false;
    },

    createItem() {
      // this.resetForm();

      this.editedItem.owner = this.decodedRouteParamOwner;
      this.editedItem.teacherprofileID = this.$route.params.teacherProfileId;
      // this.editedItem.orderPaymentMethod = "EFT";
      this.createDialog = true;
    },

    viewItem(item) {
      this.editedItem = Object.assign({}, item);

      if (item.orderShippingDetails) {
        this.shippingDetails = _.cloneDeep(item.orderShippingDetails);
        this.syncedShippingDetails = _.cloneDeep(item.orderShippingDetails);
      } else {
        this.shippingDetails = Object.assign({}, this.defaultShippingDetails);
        this.syncedShippingDetails = null;
      }

      this.dialog = true;
    },

    editItem(item) {
      this.resetForm();
      this.editedIndex = this.productOrderModels.indexOf(item);
      // this.editedItem = Object.assign({}, item);
      this.editedItem = _.cloneDeep(item);

      if (item.orderShippingDetails) {
        this.shippingDetails = _.cloneDeep(item.orderShippingDetails);
        this.syncedShippingDetails = _.cloneDeep(item.orderShippingDetails);
      } else {
        this.shippingDetails = _.cloneDeep(this.defaultShippingDetails);
        this.syncedShippingDetails = null;
      }

      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.createDialog = false;
      this.$nextTick(() => {
        this.resetForm();
      });
    },
  },

  beforeDestroy() {
    if (this.productOrdersSubCreate) this.productOrdersSubCreate.unsubscribe();
    if (this.productOrdersSubUpdate) this.productOrdersSubUpdate.unsubscribe();
    if (this.productOrdersSubDelete) this.productOrdersSubDelete.unsubscribe();
    if (this.productsSubCreate) this.productsSubCreate.unsubscribe();
    if (this.productsSubUpdate) this.productsSubUpdate.unsubscribe();
    if (this.productsSubDelete) this.productsSubDelete.unsubscribe();
    if (this.productBundlesSubCreate)
      this.productBundlesSubCreate.unsubscribe();
    if (this.productBundlesSubUpdate)
      this.productBundlesSubUpdate.unsubscribe();
    if (this.productBundlesSubDelete)
      this.productBundlesSubDelete.unsubscribe();
  },
};
</script>
